import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import fr from "date-fns/locale/fr/";
import { useMaterialUIController, setPageContent } from "context";

import { selectCurrentErrors } from 'context/auth/authSlice';
import { useDeleteUserMutation, useDeleteProfilePhotoMutation } from 'context/users/usersApiSlice';
import { useDeletePagePhotoMutation, useDeletePageMutation } from 'context/pages/pageApiSlice';
import { useDeleteProductMutation, useUpdateDistributorProductMutation, useDeleteProductPhotoMutation } from 'context/product/productApiSlice';
import { useDeleteCategoryMutation } from 'context/category/categoryApiSlice';
import { useDeleteDistributerMutation } from 'context/distributer/distributerApiSlice';
import { useDeleteDistributerCategoryMutation } from 'context/distributer/distributerCategoryApiSlice';
import { useDeleteNotificationMutation } from 'context/notification/notificationsApiSlice';
// Material Dashboard 2 React Components
// @mui material components
import useCart from "hooks/useCart";
import useAlert from "hooks/useAlert";
import Slide from '@mui/material/Slide';
import MDBox from 'dashboard/components/MDBox';
import MDButton from 'dashboard/components/MDButton';
import MDSnackbar from 'dashboard/components/MDSnackbar';
import MDTypography from 'dashboard/components/MDTypography';

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
const Alert = () => {
    const [controller, dispatch] = useMaterialUIController();
    const { pageContent }   = controller;
    const stateAlertMesage  = useSelector(selectCurrentErrors);
    const [deleteUser]      = useDeleteUserMutation();
    const [deletePage]      = useDeletePageMutation();
    const [deleteProfilePhoto] = useDeleteProfilePhotoMutation();
    const [deletePagePhoto]    = useDeletePagePhotoMutation();
    const [deleteProduct]      = useDeleteProductMutation();
    const [deleteProductPhoto]      = useDeleteProductPhotoMutation();
    const [deleteCategory]     = useDeleteCategoryMutation();
    const [deleteDistributer]      = useDeleteDistributerMutation();
    const [deleteDistributerCategory]      = useDeleteDistributerCategoryMutation();
    const [deleteDistributerProduct] = useUpdateDistributorProductMutation() ; 
    const [deleteNotification] = useDeleteNotificationMutation() ; 

    const { emptyCart } = useCart();
    const {hideAlerts, showAlerts} = useAlert();
    const date = format(Date.now() , 'dd MMM yy\tHH:mm', {locale:fr})
    
    const [state, setState] = useState({
      open: false,
      vertical: 'top',
      horizontal: 'right',
    });
    const { vertical, horizontal, open } = state;
    
    useEffect(() => {
      if(stateAlertMesage.msg)  setState({ ...state, open: true });
    }, [stateAlertMesage]);
     
    const handleClose = () => {
      hideAlerts();
      setState({ ...state, open: false });
    };
    
    const ConfirmDelet = async () =>{
      handleClose();
      switch(stateAlertMesage.title) {
        case "Delete user":
          try{
            const response = await deleteUser({id : stateAlertMesage.action}).unwrap();
            showAlerts({code:"success", title : "Delete User", msg : response.message, type : "toast"});
          }catch (error){
            showAlerts({code:"error", title : "Delete User", msg : error?.data?.message, type : "toast"});
          }
          break;
        case "Delete Profile photo":
          try{
            const response = await deleteProfilePhoto(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete Profile photo", msg : response.message, type : "toast"});
          }catch (error){
            showAlerts({code:"error", title : "Delete Profile photo", msg : error?.data?.error, type : "toast"});
          }
        break;
        case "Delete page":
          try{
            const response = await deletePage({id : stateAlertMesage.action}).unwrap();
            showAlerts({code:"success", title : "Delete page", msg : response.message, type : "toast"});
          }catch (error){
            showAlerts({code:"error", title : "Delete page", msg : error?.data?.message, type : "toast"});
          }
        break;
        case "Delete product" : 
          try{
            const response = await deleteProduct(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete product", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Delete Product", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Supprimer la photo de produit" : 
          try{
            const response = await deleteProductPhoto(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Supprimer la photo", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Supprimer la photo", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Supprimer une notification":
          try{
            const response = await deleteNotification({id : stateAlertMesage.action.id}).unwrap();
            showAlerts({code:"success", title : "Supprimer une notification", msg : response.message, type : "toast"});
          }catch (error){
            showAlerts({code:"error", title : "Supprimer une notification", msg : error?.data?.message, type : "toast"});
          }
        break;
        case "Supprimer une catégorie" : 
          try{
            const response = await deleteCategory(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete category", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Delete category", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Delete distributer" : 
          try{
            const response = await deleteDistributer(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete distributer", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Delete distributer", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Delete distributer Category" : 
          try{
            const response = await deleteDistributerCategory(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete distributer Category", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Delete distributer Category", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Delete Distributor product" : 
          try{
            const response = await deleteDistributerProduct(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete product for distributer", msg : response.message, type : "toast"});     
          }catch(errors){
            showAlerts({code:"error", title : "Delete product for distributer", msg : errors?.data?.error, type : "toast"});
          }
        break;
        case "Empty cart" : 
          try{
            emptyCart();
            showAlerts({code:"success", title : "Empty cart", msg : "Votre panier a été vidé", type : "toast"});  
          }catch(errors){
            showAlerts({code:"error", title : "Empty cart", msg : "Impossible de vider le panier", type : "toast"});
          }
        break;
        case "Delete Page photo":
          try{
            const response = await deletePagePhoto(stateAlertMesage.action).unwrap();
            showAlerts({code:"success", title : "Delete Logo", msg : response.message, type : "toast"});
            const images = pageContent[stateAlertMesage.action.section].photos.images.filter( item => item.id !== stateAlertMesage.action.imgId);
            setPageContent(dispatch,
                {
                ...pageContent,
                  [stateAlertMesage.action.section] : {
                    ...pageContent[stateAlertMesage.action.section],
                    photos : {
                      ...pageContent[stateAlertMesage.action.section].photos,
                      images : images 
                  }
                }
              });
          }catch(errors){
            showAlerts({code:"error", title : "Delete Logo", msg : errors?.data?.error, type : "toast"});
          }
        break;
        default:
          // code block
      }
      
    }
    let content = "";
    if (stateAlertMesage.type === "confirm"){
      content = <MDBox>
        <MDTypography  variant="subtitle2" color={!stateAlertMesage.bgWhite ? "white" : "dark"}>{stateAlertMesage.msg}</MDTypography>
        <MDBox sx={{mt:1}}>
          <MDButton variant="gradient" size="small" color={!stateAlertMesage.bgWhite ? "light" : stateAlertMesage.code} sx={{mr:2}} onClick={ConfirmDelet}>confirm</MDButton>
          <MDButton variant="outlined" size="small" color={!stateAlertMesage.bgWhite ? "light" : stateAlertMesage.code} onClick={handleClose}>decline</MDButton>
        </MDBox>
      </MDBox>
    }else{
      content = stateAlertMesage.msg || "an error was found"
    }
  return (
      <MDSnackbar
        bgWhite={stateAlertMesage.bgWhite}
        anchorOrigin={{ vertical, horizontal }}
        color={stateAlertMesage.code}
        icon={stateAlertMesage.icon}
        title={stateAlertMesage.title}
        content={content}
        dateTime={date}
        open={open}
        autoHideDuration={stateAlertMesage.type === 'confirm' || stateAlertMesage.title === 'User registration' ? 10000 : 4000}
        close={handleClose}
        TransitionComponent={SlideTransition}
      />
  )
}

export default Alert